// hooks/useActivePath.js
import { useLocation } from 'react-router-dom';

export const useActivePath = () => {
    const location = useLocation();

    const isExactActive = (path) => {
        return location.pathname === path;
    };

    const isParentActive = (path) => {
        return location.pathname.startsWith(path) && location.pathname !== path;
    };

    return { isExactActive, isParentActive };
};